import { render } from "./BottomNavigation.vue?vue&type=template&id=05537636&scoped=true"
import script from "./BottomNavigation.vue?vue&type=script&lang=js"
export * from "./BottomNavigation.vue?vue&type=script&lang=js"

import "./BottomNavigation.vue?vue&type=style&index=0&id=05537636&lang=scss&scoped=true"

import exportComponent from "/Users/hanssagita/Documents/freelance/gunsa2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05537636"]])

export default __exports__